import Request from "./Request";
export class EventRequest extends Request {
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/api-ai-javascript/es6/Request/EventRequest.js
// module id = 20
// module chunks = 0